<template>
  <div class="white-outline-button">
    <button class="btn" :class="[stretchToFill? 'stretch' : '']" v-on:click="clicked">
      <span :class="[ noResizeText? '' : 'resizeText']">{{ buttonText }} </span></button>
  </div>
</template>

<script>

  export default {
    name: "WhiteOutlineButton",
    components: {},
    props: {
      buttonText: String,
      stretchToFill: Boolean,
      noResizeText: Boolean,
    },
    data() {
      return {}
    },
    computed: {},

    mixins: [],
    methods: {
      clicked() {
        this.$emit("clicked");
      }
    },
    mounted() {

    },
    created() {

    }
  }


</script>

<style lang="scss" scoped>

  @mixin aspect-ratio($width, $height) {
    position: relative;
    &:before {
      display: block;
      content: "";
      width: 100%;
      padding-top: ($height / $width) * 100%;
    }
    > .content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  .white-outline-button {

    display: flex;
    justify-content: center;

    &.first {
      margin-top: 35%;
    }

    .btn {
      //width: 100%;
      //height: 100%;
      //padding: 0px 60px;
      //padding: 0px 15%;

      //position: relative;
      //height: auto;
      //min-height: 100% !important;

      min-height: 50px;
      min-width: 250px;

      &.stretch {
        width: 100%;
      }

      background-image: url("~@/assets/image/button/bb_button.svg");
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      color: white;
      font-weight: bold;
    }


  }

  .resizeText {
    font-size: min(2.5vw, 2.5vh); 
  }


</style>